var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.374,
    height: 21.808,
    viewBox: "0 0 21.374 21.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7123025_logo_google_g_icon",
    "data-name": "7123025_logo_google_g_icon",
    transform: "translate(-30.025 -29.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M86.376,69.009a13.638,13.638,0,0,0-.19-2.209H75.9V71h5.891a4.956,4.956,0,0,1-2.185,3.3l3.516,2.732a10.723,10.723,0,0,0,3.254-8.029Z",
    transform: "translate(-34.977 -28.746)",
    fill: "#4280ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M44.64,92.689a10.431,10.431,0,0,0,7.222-2.637l-3.516-2.708A6.614,6.614,0,0,1,38.511,83.9L34.9,86.679A10.893,10.893,0,0,0,44.64,92.689Z",
    transform: "translate(-3.717 -41.783)",
    fill: "#34a353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M34.794,61.384a6.624,6.624,0,0,1,0-4.181l-3.611-2.8a10.918,10.918,0,0,0,0,9.787Z",
    transform: "translate(0 -19.291)",
    fill: "#f6b704"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M44.64,33.422a5.949,5.949,0,0,1,4.181,1.639l3.112-3.136A10.493,10.493,0,0,0,44.64,29.1a10.893,10.893,0,0,0-9.74,6.01l3.611,2.8A6.523,6.523,0,0,1,44.64,33.422Z",
    transform: "translate(-3.717 0)",
    fill: "#e54335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.041a6ad6cbf66bb5405e4467d6fbbd05.svg";
export { ForwardRef as ReactComponent };